import { render, staticRenderFns } from "./TheNewspaperIcon.vue?vue&type=template&id=72b06ef8&"
import script from "./TheNewspaperIcon.vue?vue&type=script&lang=js&"
export * from "./TheNewspaperIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports